// Copyright (c) Microsoft. All rights reserved.

import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { initialState, AIModelsState, AIModels, IUsage} from '../../../libs/models/app/AIModel';

export const modelSlice = createSlice({
  name: 'model',
  initialState,
  reducers: {
    setSelectedModel: (state: AIModelsState, action: PayloadAction<string | null>) => {
      if (action.payload !== null) {
        if (Object.keys(state.models).includes(action.payload)) {
          state.selectedModel = state.models[action.payload];
        } else {
          // 목록에 없는 모델 도 처리
          state.selectedModel = {
            model: action.payload,
            displayName: action.payload,
            description: '',
            isAvailable: true,
            vendor: '',
            profileUrl: initialState.selectedModel.profileUrl,
            isDefault: false,
          };
        }
      } else state.selectedModel = initialState.selectedModel;
    },
    addModels: (state: AIModelsState, action: PayloadAction<AIModels>) => {
      state.models = action.payload;
      const models = state.models;
      const defaultModel = Object.values(models).find(c=>c.isDefault);
      if(defaultModel) {
        if(defaultModel.isAvailable) 
          state.selectedModel = action.payload[defaultModel.model];
      }
      else state.selectedModel = action.payload[initialState.selectedModel.model];
    },
    updateModelUsage: (state: AIModelsState, action: PayloadAction<IUsage>) => {
      const usage = action.payload;
      state.models[usage.modelName].usage = usage;
      const selectedModel = state.selectedModel;
      if (selectedModel.model == usage.modelName) {
        selectedModel.usage = usage;
      }
    },
  },
});

export const { setSelectedModel, addModels } = modelSlice.actions;

export default modelSlice.reducer;
